export default __webpack_public_path__ + "pgnv-assets/72ce2510bf190a43c6b4b3f65edec798.svg";